import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_TABLE_CELL__inputs__node_type({ field }: PROPS) {
  return <span className="font-mono">{field.meta.node_type}</span>;
}
